<template>
  <info-tool-tip-help-popup class="expense-investigation-help-popup"
    :title="'מתי המערכת מקטלגת הוצאה כהוצאה קבועה?'"
    :cx-dude="{ name: 'nofar', displayName: 'נופר' }"
    :popup-name="'ExpenseInvestigationHelpPopup'"
    :on-close="onClose">
    <template v-slot:description>
      <div class="description">
        כשהמערכת מזהה באופן אוטומטי שבמשך 3 חודשים ברצף התבצע חיוב לאותו בית עסק,
         בסכום דומה וסביב אותו יום בחודש היא תסמן את חיוב זה כהוצאה קבועה ותצפה אותו גם בחודשים הקרובים.
        <div>&nbsp;</div>
        במידה והמערכת פיספסה הוצאה מסוימת אפשר לסמן אותה ידנית כהוצאה קבועה.
      </div>
    </template>
  </info-tool-tip-help-popup>
</template>

<script>

import InfoToolTipHelpPopup from '../InfoToolTipHelpPopup.vue';

export default {
  name: 'ExpenseInvestigationHelpPopup',
  components: {
    InfoToolTipHelpPopup,
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .expense-investigation-help-popup {
    .description {
      a {
        color: $riseup_light_blue;
        font-weight: bold;
      }
      .bold {
        font-weight: bold;
      }
    }
  }

</style>
